<template>
    <v-card v-redirect-if-no-permission:SALARIES_MONITORING>
        <h1 style="text-align: center;padding: 10px">SALARY REPORTS</h1>
        <all-salary-reports></all-salary-reports>
    </v-card>
</template>

<script>
    import AllSalaryReports from "@/views/HRAccounting/AllSalaryReports";
    export default {
        name: "AllSalaryReportIndex",
        components: {AllSalaryReports}
    }
</script>

<style scoped>

</style>